const initState = {  
  account: {},
  payload: null,
  toast: null,
  isProcessing: false,
};

export const registrationReducer = (state = initState, action) => {
  switch (action.type) {
  case 'RESET_REGISTRATION_STATE':
    return { 
      ...initState
    };
  case 'SENDING_EMAIL':
    return {
      ...state,
      isProcessing: true,
      toast: { type: 'LOADING', action: 'EMAIL', message: 'Sending verification email. please wait'},
    };
  case 'PROCESSING_VERIFICATION':
    return {
      ...state,
      isProcessing: true,
      toast: { type: 'LOADING', action: 'VERIFICATION', message: 'Email verification in progress. Please wait'},
    };
  case 'PROCESSING_REGISTRATION':
    return {
      ...state,
      isProcessing: true,
      toast: { type: 'LOADING', message: 'Registration in progress.'},
    };

  case 'EMAIL_SENT_SUCCESS':
    return {
      isProcessing: false,
      payload: action.payload,
      toast: { type: 'EMAIL_SUCCESS', action: 'EMAIL', message: 'Verification email sent. Please check your inbox or look into your spam folder.'}
    };
  case 'EMAIL_SENT_ERROR':
    return {
      ...state,
      isProcessing: false,
      payload: action.payload,
      toast: { type: 'EMAIL_ERROR', message: action.payload }
    };

  case 'VERIFICATION_SUCCESS':
    return {
      isProcessing: false,
      payload: action.payload,
      toast: { type: 'VERIFY_SUCCESS', action: 'VERIFICATION', message: 'Email verified successfully.'}
    };

  case 'VERIFICATION_ERROR':
    return {
      ...state,
      isProcessing: false,
      payload: action.paylaod,
      toast: { type: 'VERIFY_ERROR', message: action.payload }
    };
  case 'REGISTRATION_SUCCESS':
    return {
      isProcessing: false,
      account: action.payload,
      toast: { type: 'SUCCESS', action: 'REGISTRATION', message: 'Registration Successful. Please login using your email and password.'}
    };
  case 'REGISTRATION_ERROR':
    return {
      ...state,
      isProcessing: false,
      toast: { type: 'ERROR', action: 'REGISTRATION', message: action.payload }
    };
  default:
    return state;
  }
};
